import {HRVSearchRequest} from 'api/analysisApi'
import {useHistory, useLocation} from 'react-router-dom'
import {
  searchEegSummary,
  selectError,
  selectItems,
  selectLoading,
  selectPaging,
  selectPagingInfo,
  selectPeriod,
  selectQuery,
  selectSearch,
} from 'features/analysis/eegSummarySlice'
import {
  searchEegSummaryFiveIndicators,
  selectErrorFiveIndicators,
  selectItemsFiveIndicators,
  selectLoadingFiveIndicators,
  selectPagingFiveIndicators,
  selectPagingInfoFiveIndicators,
  selectPeriodFiveIndicators,
  selectQueryFiveIndicators,
  selectSearchFiveIndicators,
} from 'features/analysis/eegSummaryFiveIndicatorsSlice'
import {
  searchEegSummaryBrainFunctionConnectivity,
  selectErrorBrainFunctionConnectivity,
  selectItemsBrainFunctionConnectivity,
  selectLoadingBrainFunctionConnectivity,
  selectPagingBrainFunctionConnectivity,
  selectPagingInfoBrainFunctionConnectivity,
  selectPeriodBrainFunctionConnectivity,
  selectQueryBrainFunctionConnectivity,
  selectSearchBrainFunctionConnectivity,
} from 'features/analysis/eegSummaryBrainFunctionConnectivitySlice'

import {useAppDispatch, useAppSelector} from 'hooks'

export default function useEegSummarySearch() {
  const history = useHistory()
  const location = useLocation()
  const dispatch = useAppDispatch()

  const loading = useAppSelector(selectLoading)
  const error = useAppSelector(selectError)
  const items = useAppSelector(selectItems)

  const period = useAppSelector(selectPeriod)
  const paging = useAppSelector(selectPaging)
  const pagingInfo = useAppSelector(selectPagingInfo)
  const search = useAppSelector(selectSearch)
  const query = useAppSelector(selectQuery)

  const onSearch = (payload: HRVSearchRequest) => {
    try {
      const params = new URLSearchParams(
        Object.entries(payload).map(([key, value]) => [
          key,
          typeof value === 'object' ? JSON.stringify(value) : value,
        ]),
      )
      history.replace({pathname: location.pathname, search: params.toString()})
    } catch (error) {
      console.error('Update URLSearchParams failed', error)
    }
    return dispatch(searchEegSummary(payload))
  }

  return {
    loading,
    error,
    items,
    period,
    paging,
    pagingInfo,
    search,
    query,
    onSearch,
  }
}

export function useEegSummaryFiveIndicatorsSearch() {
  const history = useHistory()
  const location = useLocation()
  const dispatch = useAppDispatch()

  const loading = useAppSelector(selectLoadingFiveIndicators)
  const error = useAppSelector(selectErrorFiveIndicators)
  const items = useAppSelector(selectItemsFiveIndicators)

  const period = useAppSelector(selectPeriodFiveIndicators)
  const paging = useAppSelector(selectPagingFiveIndicators)
  const pagingInfo = useAppSelector(selectPagingInfoFiveIndicators)
  const search = useAppSelector(selectSearchFiveIndicators)
  const query = useAppSelector(selectQueryFiveIndicators)

  const onSearch = (payload: HRVSearchRequest) => {
    try {
      const params = new URLSearchParams(
        Object.entries(payload).map(([key, value]) => [
          key,
          typeof value === 'object' ? JSON.stringify(value) : value,
        ]),
      )
      history.replace({pathname: location.pathname, search: params.toString()})
    } catch (error) {
      console.error('Update URLSearchParams failed', error)
    }
    return dispatch(searchEegSummaryFiveIndicators(payload))
  }

  return {
    loading,
    error,
    items,
    period,
    paging,
    pagingInfo,
    search,
    query,
    onSearch,
  }
}

export function useEegSummaryBrainFunctionConnectivitySearch() {
  const history = useHistory()
  const location = useLocation()
  const dispatch = useAppDispatch()

  const loading = useAppSelector(selectLoadingBrainFunctionConnectivity)
  const error = useAppSelector(selectErrorBrainFunctionConnectivity)
  const items = useAppSelector(selectItemsBrainFunctionConnectivity)

  const period = useAppSelector(selectPeriodBrainFunctionConnectivity)
  const paging = useAppSelector(selectPagingBrainFunctionConnectivity)
  const pagingInfo = useAppSelector(selectPagingInfoBrainFunctionConnectivity)
  const search = useAppSelector(selectSearchBrainFunctionConnectivity)
  const query = useAppSelector(selectQueryBrainFunctionConnectivity)

  const onSearch = (payload: HRVSearchRequest) => {
    try {
      const params = new URLSearchParams(
        Object.entries(payload).map(([key, value]) => [
          key,
          typeof value === 'object' ? JSON.stringify(value) : value,
        ]),
      )
      history.replace({pathname: location.pathname, search: params.toString()})
    } catch (error) {
      console.error('Update URLSearchParams failed', error)
    }
    return dispatch(searchEegSummaryBrainFunctionConnectivity(payload))
  }

  return {
    loading,
    error,
    items,
    period,
    paging,
    pagingInfo,
    search,
    query,
    onSearch,
  }
}
